export default "__VITE_ASSET__CqTp1I4A__"